(function () {
  const COOKIE = 'gma_popup_seen';
  const COOKIE_DAYS = 30;

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  var popup = document.getElementById('welcome-popup');
  if (!popup) return;
  if (getCookie(COOKIE) === '1') return;

  var DELAY_MS = parseInt(popup.dataset.delay, 10) || 10000;

  function openPopup() {
    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    popup.style.display = 'none';
    document.body.style.overflow = '';
    setCookie(COOKIE, '1', COOKIE_DAYS);
  }

  setTimeout(function () {
    openPopup();

    var closeBtn = document.getElementById('popup-close');
    var dismissBtn = document.getElementById('popup-dismiss');
    var successCloseBtn = document.getElementById('popup-success-close');
    var form = document.getElementById('popup-form');
    var emailInput = document.getElementById('popup-email');
    var errorMsg = document.getElementById('popup-error');
    var offerPanel = document.getElementById('popup-offer');
    var successPanel = document.getElementById('popup-success');

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (dismissBtn) dismissBtn.addEventListener('click', closePopup);
    if (successCloseBtn) successCloseBtn.addEventListener('click', closePopup);

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var email = emailInput ? emailInput.value.trim() : '';
        var emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        if (!emailValid) {
          if (errorMsg) errorMsg.style.display = 'block';
          if (emailInput) emailInput.focus();
          return;
        }

        if (errorMsg) errorMsg.style.display = 'none';

        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' }
        }).catch(function () {});

        if (offerPanel) offerPanel.style.display = 'none';
        if (successPanel) successPanel.style.display = 'block';

        setCookie(COOKIE, '1', COOKIE_DAYS);
      });
    }
  }, DELAY_MS);
})();
